<template>
  <div class="textlink" :style="boxStyle">
      <span class="text-inner" :style="detailData.viewStyle">{{detailData.content.text}}</span>
      <span class="img iconfont icon-xiangyou" v-if="detailData.showIcon" :style="detailData.iconStyle"></span>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'TextLink',
  mixins: [mixins],
  props: {
  },
  components: {},
  data() {
    return {
      detailData: {
        content: {}
      },
      pattern: {}
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      let textAlign = this.pattern.textAlign || 2
      let textAlignStr = textAlign == 1 ? "left" : textAlign == 2 ? "center" : "right"
      let obj = {
        "padding-left": (this.pattern.margin || 0) + 'px',
        "padding-right": (this.pattern.margin || 0) + 'px',
        "background-color":this.pattern.bgColor,
        "text-align": textAlignStr
      }
      if(this.pattern.borederColor){
        obj["border-color"] = this.pattern.borederColor
      }
      return obj
    },
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern
      console.log("TextLink----------this.detailData");
      console.log(this.detailData);
    }
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.textlink{
    border: 1px solid transparent;
    .text-inner{
        // white-space:nowrap;
        // overflow:hidden;
        // text-overflow:ellipsis;

    }
    .img{
      text-decoration: none
    }
}
</style>
